import { useState, useEffect } from "react";
import withStyles from "react-jss";
import "./DecisionTree.css";
import { downArrow } from "../../assets/images";

const styles = {
  main: {
    position: "relative",
    width: "100%",
    display: "flex",
    maxWidth: "1140px",
    margin: "0 auto",
    padding: 0,
    color: "#ffffff",
    boxSizing: "border-box",
    "@media only screen and (max-width: 840px)": {
      flexDirection: "column",
    },
  },
  right: {
    boxSizing: "border-box",
    position: "relative",
    width: "55%",
    margin: 0,
    // background: "grey",
    "@media only screen and (max-width: 840px)": {
      position: "sticky",
      bottom: 0,
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      height: "100vh",
    },
  },
  left: {
    boxSizing: "border-box",
    width: "45%",
    padding: "0 16px",
    zIndex: 2,
    "@media only screen and (max-width: 840px)": {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
    },
    "& p": {
      fontFamily: "BreveText",
      fontSize: "19px",
    },
  },
  text: {
    width: "100%",
    maxWidth: "460px",
    boxSizing: "border-box",
    fontFamily: "BreveText",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    margin: "80vh auto",
    padding: "16px 24px",
    background: "#ffffff",
    borderRadius: "4px",
    color: "#000000",
    "@media only screen and (max-width: 840px)": {
      padding: "16px",
      margin: "100vh auto",
    },
  },
  rightBox: {
    top: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "sticky",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingBottom: "50px",
    "@media (max-width: 780px)": {
      justifyContent: "end",
    },
    "& p": {
      fontFamily: "WiredMono",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      display: "flex",
      justifyContent: "space-between",
      textTransform: "uppercase",
      flexDirection: "column",
      margin: 0,
    },
  },
  rightBoxContent: {
    width: "100%",
  },
};

const DecisionTree = ({ classes, mainId }) => {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const items = Array.from(document.querySelectorAll(`#${mainId} article p`));

    const imgs = document.querySelectorAll(
      "#contentScoreDecisionTree .rightBox .rightBoxContent .rightBoxContentPara"
    );
    const imgsMale = document.querySelectorAll(
      "#contentScoreDecisionTreeMale .rightBoxMale .rightBoxContentMale .rightBoxContentParaMale"
    );
    const femaleTree = document.querySelector(".femaleDecisionTree ");

    const maleTree = document.querySelector(".maleDecisionTree");
    const imgsNumber = document.querySelectorAll(".hideNumber");
    const imgsNumberMale = document.querySelectorAll(".hideNumberMale");
    const imgstep = document.querySelector(".initialStepBorder");
    const imgstepMale = document.querySelector(".initialStepBorderMale");
    const imgsColor = document.querySelectorAll(".colorChange");

    const detectIntersection = (entries) => {
      for (let e of entries) {
        let j = items.indexOf(e.target);
        if (e.isIntersecting && j === 0) {
          maleTree.classList.add("hideTree");
          for (let j = 0; j < imgs.length; j++) {
            imgsMale[j] && imgsMale[j].classList.remove("visible");
          }
          for (let i = 0; i < 5; i++) {
            setTimeout(function timer() {
              imgs[i] && imgs[i].classList.add("visible");
            }, i * 500);
            if (i === 3) {
              setTimeout(function timer() {
                for (let j = 0; i < imgsNumber.length; j++) {
                  if (imgsNumber[j].classList.contains("showNumber")) {
                    imgsNumber[j].classList.remove("hideNumber");
                    imgsNumber[j].classList.add("visibleNumber");
                  } else {
                    imgsNumber[j].classList.remove("hideNumber");
                    imgsNumber[j].classList.add("visibleFirstNumber");
                  }
                }
              }, i * 500);
            }
            if (i === 4) {
              setTimeout(function timer() {
                for (let k = 0; k < imgsColor.length; k++) {
                  if (imgsColor[k].classList.contains("addRedColor")) {
                    imgsColor[k].classList.add("redColor");
                  }
                  if (imgstep.classList.contains("addStepColor")) {
                    imgstep.classList.remove("stepBorderWhite");
                    imgstep.classList.add("stepBorderRed");
                  }
                }
              }, i * 500);
            }
          }
          e.target.classList.add("visible");
        } else if (e.isIntersecting && j === 1) {
          femaleTree.classList.add("hideTree");
          maleTree.classList.add("showTree");
          for (let k = 0; k < imgs.length; k++) {
            imgs[k] && imgs[k].classList.remove("visible");
          }
          femaleTree.classList.add("hideTree");
          for (let i = 0; i < 5; i++) {
            setTimeout(function timer() {
              imgsMale[i] && imgsMale[i].classList.add("visible");
            }, i * 500);
            if (i === 2) {
              setTimeout(function timer() {
                for (let j = 0; i < imgsNumberMale.length; j++) {
                  if (imgsNumberMale[j].classList.contains("showNumber")) {
                    imgsNumberMale[j].classList.remove("hideNumber");
                    imgsNumberMale[j].classList.add("visibleNumber");
                  } else {
                    imgsNumberMale[j].classList.remove("hideNumber");
                    imgsNumberMale[j].classList.add("visibleFirstNumber");
                  }
                }
              }, i * 500);
            }
            if (i === 3) {
              setTimeout(function timer() {
                for (let k = 0; k < imgsColor.length; k++) {
                  if (imgsColor[k].classList.contains("addGreenColor")) {
                    imgsColor[k].classList.add("greenColor");
                  }
                  if (imgstepMale.classList.contains("addStepColorMale")) {
                    imgstepMale.classList.remove("stepBorderWhite");
                    imgstepMale.classList.add("stepBorderGreen");
                  }
                }
              }, i * 500);
            }
            e.target.classList.add("visible");
          }
        } else if (!e.isIntersecting && j === 1) {
          femaleTree.classList.remove("hideTree");
          femaleTree.classList.add("showTree");
          // maleTree.classList.add("hideTree");
        } else if (!e.isIntersecting && j === 0) {
          maleTree.classList.remove("hideTree");
          maleTree.classList.add("showTree");
          // femaleTree.classList.add("hideTree");
        }
      }
    };

    const options = {
      threshold: 0.25,
    };

    const observer = new IntersectionObserver(detectIntersection, options);
    items.forEach((i) => {
      observer.observe(i);
    });
  }, []);

  return (
    <section className={classes.main} id={mainId}>
      {(!load && (
        <>
          <article className={classes.left}>
            <p className={classes.text}>
              Yara is the mother of two children. She recently moved after
              splitting up with her long term partner. The decision tree
              calculates the average score for a person with these
              characteristics this to be <b>69.1</b>.
            </p>
            <p className={classes.text}>
              Now, let's look at what happens when we change just one thing
              about Yara: her gender. While Yara was asked about her
              relationship status, children, and living situation, this male
              doppelganger is asked an entirely different set of questions. The
              tree produces an average score of <b>58.2</b> for an individual
              with these traits.
            </p>
          </article>
          <figure className={classes.right}>
            <div className={classes.rightBox}>
              <div className={classes.rightBoxContent}>
                <section id="contentScoreDecisionTree">
                  <div className="rightBox femaleDecisionTree">
                    <div className="rightBoxContent decisionTreeBox">
                      <div className="rightBoxContentPara initialStep">
                        <div className="titleText">Are you female?</div>

                        <div className="initialStepBorder addStepColor stepBorderWhite visible"></div>
                        <img
                          className="downArrowStepFirst"
                          src={downArrow}
                          alt="down arrow"
                        ></img>
                        <div className="downArrowStepTextBoxFirst">
                          <div className="stepTextLeft colorChange addRedColor">
                            YES
                          </div>
                          <div className="stepTextRight">
                            NO
                            <div className="hideMaleScore showMaleScore">
                              0.451
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="rightBoxContentPara">
                        <div className="firstStep">
                          <div className="colorChange addRedColor firstStepText">
                            {"Number of Children <0"}
                          </div>
                          <img
                            className="downArrowStep"
                            src={downArrow}
                            alt="down arrow"
                          ></img>
                          <div className="downArrowStepTextBox">
                            <div className="stepTextLeft colorChange addRedColor">
                              {" Recent Home addresses <6"}
                            </div>
                            <div className="stepTextRight ">
                              NO
                              <div className="hideNumber showNumber">55.8</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="rightBoxContentPara secondStep">
                        <img
                          className="downArrowStep"
                          src={downArrow}
                          alt="down arrow"
                        ></img>
                        <div className="downArrowStepTextBox">
                          <div className="stepTextLeft colorChange addRedColor">
                            {"days with partner >206 days"}
                          </div>
                          <div className="stepTextRight">
                            NO
                            <div className="hideNumber showNumber">55.8</div>
                          </div>
                        </div>
                      </div>
                      <div className="rightBoxContentPara thirdStep">
                        <img
                          className="downArrowStep"
                          src={downArrow}
                          alt="down arrow"
                        ></img>
                        <div className="downArrowStepTextBox">
                          <div className="stepTextLeft colorChange addRedColor">
                            YES
                            <div className="hideNumber showNumber">69.1</div>
                          </div>
                          <div className="stepTextRight">
                            NO
                            <div className="hideNumber showNumber">63.8</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section id="contentScoreDecisionTreeMale">
                  <div className="rightBoxMale maleDecisionTree">
                    <div className="rightBoxContentMale decisionTreeBox">
                      <div className="rightBoxContentParaMale initialStepMale">
                        <div className="">Are you female?</div>
                        <div className="initialStepBorderMale addStepColorMale stepBorderWhite"></div>
                        <img
                          className="downArrowStepFirstMale"
                          src={downArrow}
                          alt="down arrow"
                        ></img>
                        <div className="downArrowStepTextBoxFirstMale">
                          <div className="stepTextLeft">YES</div>
                          <div className="stepTextRight colorChange addGreenColor">
                            NO
                          </div>
                        </div>
                      </div>
                      <div className="rightBoxContentParaMale">
                        <div className="firstStepMale">
                          <div className="colorChange addGreenColor firstStepText">
                            {">194 days since language req.?"}
                          </div>
                          <img
                            className="downArrowStep"
                            src={downArrow}
                            alt="down arrow"
                          ></img>
                          <div className="downArrowStepTextBox">
                            <div className="stepTextLeft">
                              YES
                              <div className="hideNumberMale showNumber">
                                47.1
                              </div>
                            </div>
                            <div className="stepTextRight colorChange addGreenColor">
                              {"Financial problems?"}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="rightBoxContentParaMale secondStepMale">
                        <img
                          className="downArrowStep"
                          src={downArrow}
                          alt="down arrow"
                        ></img>
                        <div className="downArrowStepTextBox">
                          <div className="stepTextLeft colorChange addGreenColor">
                            YES
                            <div className="hideNumberMale showNumber">
                              58.2
                            </div>
                          </div>
                          <div className="stepTextRight">
                            NO
                            <div className="hideNumberMale showNumber">
                              47.2
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </figure>
        </>
      )) || (
        <div className="loadBox">
          <div className="loader"></div>
        </div>
      )}
    </section>
  );
};

export default withStyles(styles)(DecisionTree);
